import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAllIssues: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		id: 'atlassian-navigation.filters.menu.footer.view-all-issues',
		defaultMessage: 'View all issues',
		description:
			'Text on the link to global advanced issue search - being renamed from "Advanced Issue Search".',
	},
	viewAll: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX - ENABLING FLAT LINT CONFIG
		id: 'atlassian-navigation.filters.menu.footer.view-all',
		defaultMessage: 'View all filters',
		description: 'Text on the link to the filters directory.',
	},
});
